import sound from "../../../public/sounds/MessageBellC.mp3"

function toasterSound() {
    const player = new Audio(sound);
    player.play();
}

export default toasterSound;